export function setMajorId(id) {
  return window.sessionStorage.setItem('majorId', id)
}
export function getMajorId() {
  return window.sessionStorage.getItem('majorId')
}


// WEBPACK FOOTER //
// ./src/utils/index.js